export default function ($scope, $uibModalInstance) {

    $scope.ok = function () {
        $uibModalInstance.close(true);
    };

};